import { useMemo } from 'react';
import I18n from 'I18n';
import useGetAreEmailTypesAvailable from '../../EmailCreation/hooks/useGetAreEmailTypesAvailable';
export default function useGetEmailCloneTypeOptions() {
  const areEmailTypesAvailable = useGetAreEmailTypesAvailable();
  const regularEmailType = useMemo(() => ({
    type: 'REGULAR',
    upgradeKey: 'email-optimized-content',
    isLocked: !areEmailTypesAvailable(['BATCH_EMAIL']),
    illustrationName: 'successfully-connected-email',
    buttonLabel: I18n.text('email-management-creation.emailCreationTypes.REGULAR.buttonLabel'),
    buttonDescription: I18n.text('email-management-creation.emailCreationTypes.REGULAR.buttonDescription')
  }), [areEmailTypesAvailable]);
  const automatedEmailType = useMemo(() => ({
    type: 'AUTOMATED',
    upgradeKey: 'email-automated-sends',
    isLocked: !areEmailTypesAvailable(['AUTOMATED_EMAIL']),
    illustrationName: 'workflows',
    buttonLabel: I18n.text('email-management-creation.emailCreationTypes.AUTOMATED.buttonLabel'),
    buttonDescription: I18n.text('email-management-creation.emailCreationTypes.AUTOMATED.buttonDescription')
  }), [areEmailTypesAvailable]);
  return useMemo(() => [regularEmailType, automatedEmailType], [regularEmailType, automatedEmailType]);
}